<template>
    <div class="type-selects">
        <el-input
            class="search-txt"
            v-model="newValue"
            placeholder="课程名称搜索"
            size="medium"
            clearable
            @keyup.native.enter="onSearch"
        >
        </el-input>
        <el-button
           class="search-btn"
           size="medium"
           type="primary"
           @click.stop="onSearch"
        >搜索</el-button>
    </div>
</template>

<script>
    export default {
        name: "search",
        props: {
            value: String
        },
        watch: {
            value(vl){this.newValue = vl},
            newValue(vl){this.$emit('update:value', vl)}
        },
        data(){
            return {
                newValue: this.value
            }
        },
        methods: {
            onSearch(){
                this.$emit('onSearch', this.newValue)
            }
        }
    }
</script>

<style lang="scss" scoped>
.type-selects{
    display: flex;
    flex-direction: row;
    align-items: center;

    .btn{
        margin-left: 10px;
    }

    .search-txt {
        /deep/ .el-input__inner{
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
            border-right-width: 0px;
            width: 20vw;
        }
    }

    .search-btn {
        border-top-left-radius: 0px !important;
        border-bottom-left-radius: 0px !important;
        border-left-width: 0px !important;
    }
}
</style>
